module.exports = "mutation resetPassword($resetToken:String!,$newPassword:String!){resetPassword(resetToken:$resetToken,newPassword:$newPassword)}"